import styled from "styled-components";
import profile from "../../../assets/images/profile.png";
import config from "../../../config";
import { device } from "../../../theme";
import Text from "../../atoms/Text";

export const ProfileDescriptionText = styled(Text)`
  font-size: 18px;

  @media ${device.mobileL} {
    font-size: 20px;
  }

  @media ${device.tablet} {
    font-size: 22px;
  }

  @media ${device.laptop} {
    font-size: 24px;
  }
`;

export const ProfileImage = styled.img.attrs({
  src: config.image || profile,
  alt: "profile",
})`
  border-radius: 50%;
  height: 250px;
  width: 250px;

  @media ${device.laptop} {
    height: 350px;
    width: 350px;
  }
`;
